/* Mobile (<750px): the market/language toggle trigger shows full country
   name + full language name (e.g. "AUSTRALIA (AUD) / ENGLISH"), which for
   longer country names overflows into the centered logo since country names
   vary in length and can't be safely capped with a fixed pixel width.
   Swaps to just the fixed-length currency code (e.g. "AUD") on mobile,
   restores full text above 750px, and re-applies after any header
   re-render (e.g. Horizon's section morphing) via MutationObserver. */
(function () {
  var mql = window.matchMedia('(max-width: 749px)');

  function compactify(label) {
    if (label.dataset.mobileFixApplied === '1') return;
    var currencyMatch = label.textContent.match(/\(([A-Z]{3})\)/);
    var currencyCode = currencyMatch ? currencyMatch[1] : '';
    if (!currencyCode) return;
    label.dataset.fullHtml = label.innerHTML;
    label.textContent = currencyCode;
    label.dataset.mobileFixApplied = '1';
  }

  function restore(label) {
    if (label.dataset.mobileFixApplied === '1' && label.dataset.fullHtml) {
      label.innerHTML = label.dataset.fullHtml;
      delete label.dataset.mobileFixApplied;
    }
  }

  function apply() {
    document.querySelectorAll('.localization-toggle__label').forEach(function (label) {
      if (mql.matches) {
        compactify(label);
      } else {
        restore(label);
      }
    });
  }

  function init() {
    apply();
    mql.addEventListener('change', apply);
    var headerGroup = document.querySelector('#header-group');
    if (headerGroup) {
      new MutationObserver(apply).observe(headerGroup, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
